import { useEffect, useState } from 'react';
import { trackEvent } from '../../lib/analytics';

const StickyCta = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleCtaClick = () => {
    trackEvent('cta_clicked', {
      cta_label: 'reserver-sticky',
      page: 'jpo-portes-ouvertes',
    });
  };

  return (
    <div className={`sticky-cta ${show ? 'is-visible' : ''}`}>
      <div className="sticky-cta-inner">
        <div className="sticky-cta-text">
          <strong>Samedi 16 mai · 9h–13h</strong>
          <span>Portes ouvertes · Maternelle &amp; Primaire</span>
        </div>
        <a href="#rsvp" onClick={handleCtaClick} className="btn btn-primary btn-sm">
          Réserver
        </a>
      </div>
    </div>
  );
};

export default StickyCta;
